import React from 'react';
import PropTypes from 'prop-types';

class LiveEvents extends React.Component {

    render() {
        return (
            <div>
                <h4>Live events</h4>
                <div className="flex-between">
                    <div></div>
                    <a className="btn btn-primary btn-with-icon" onClick={this.props.addEvent}><i className="material-icons">add_circle_outline</i>Add event</a>
                </div>
                <table className="table productTable">
                    <thead>
                        <tr>
                            <th className="iconCell"></th>
                            <th className="titleCell">Title</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(this.props.events).map(eventKey => {
                                const event = this.props.events[eventKey];
                                if(event) {
                                    return (
                                        <tr key={eventKey}>
                                            <td className="productOfTheMonth iconCell"><i className="material-icons">dashboard</i></td>
                                            <td className="productTitle titleCell" onClick={() => this.props.showEventModal(eventKey) }>{event.title}</td>
                                            <td></td>
                                        </tr>
                                    );
                                }
                                else {
                                    return null;
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

LiveEvents.propTypes ={
    events: PropTypes.object.isRequired,
    showEventModal: PropTypes.func.isRequired,
    addEvent: PropTypes.func.isRequired
}

export default LiveEvents;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEvents.js
 **/